import LinearProgress from '@material-ui/core/LinearProgress';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { isUndefined } from 'lodash';
import React from 'react';
import { divider, primary } from '../Styles/Colours';
import styles from './FullScreenModal.module.css';
import { BackArrow, CloseIcon } from './Icons';
import { WindowEventListener } from './WindowEventListener';
export var ScrollContainerMode;
(function (ScrollContainerMode) {
    ScrollContainerMode[ScrollContainerMode["Narrow"] = 0] = "Narrow";
    ScrollContainerMode[ScrollContainerMode["FullWidth"] = 1] = "FullWidth";
})(ScrollContainerMode || (ScrollContainerMode = {}));
export var ModalAnimationStyle;
(function (ModalAnimationStyle) {
    ModalAnimationStyle[ModalAnimationStyle["OpenAndClose"] = 0] = "OpenAndClose";
    ModalAnimationStyle[ModalAnimationStyle["OpenOnly"] = 1] = "OpenOnly";
    ModalAnimationStyle[ModalAnimationStyle["CloseOnly"] = 2] = "CloseOnly";
    ModalAnimationStyle[ModalAnimationStyle["None"] = 3] = "None";
})(ModalAnimationStyle || (ModalAnimationStyle = {}));
var BorderLinearProgress = withStyles({
    root: {
        height: 8,
        backgroundColor: divider,
        width: '100%',
        position: 'fixed',
        zIndex: 1
    },
    bar: {
        backgroundColor: primary
    }
})(LinearProgress);
export function FullScreenModalInfo(props) {
    return React.createElement("div", { className: styles.info }, props.info);
}
export function FullScreenModalTitle(props) {
    return React.createElement("div", { className: styles.title }, props.title);
}
export var FullScreenModal = function (props) {
    var _a;
    var _b;
    var containerClasses = classNames(styles.container, (_a = {},
        _a[styles.animationFull] = props.modalAnimationStyle === undefined || props.modalAnimationStyle === ModalAnimationStyle.OpenAndClose,
        _a[styles.animationOpenOnly] = props.modalAnimationStyle === ModalAnimationStyle.OpenOnly,
        _a[styles.animationCloseOnly] = props.modalAnimationStyle === ModalAnimationStyle.CloseOnly,
        _a));
    return (React.createElement(WindowEventListener, { onKeyDown: function (e) {
            if (props.nonInteractivePlaceholder)
                return;
            if (e.key === 'Escape') {
                props.onClose();
            }
        } },
        React.createElement("div", { className: containerClasses },
            !props.nonInteractivePlaceholder && !isUndefined(props.progressPercent) && (React.createElement(BorderLinearProgress, { variant: 'determinate', color: 'secondary', value: props.progressPercent })),
            !!props.hideBackButton === false && !props.nonInteractivePlaceholder && props.onBack && (React.createElement("div", { className: styles.backButton, onClick: props.onBack, "data-test-id": "navigation-control-back" },
                React.createElement(BackArrow, null))),
            !props.nonInteractivePlaceholder && (React.createElement("div", { className: styles.closeButton, onClick: props.onClose, "data-test-id": "navigation-control-close" },
                React.createElement(CloseIcon, null))),
            React.createElement("div", { className: styles.body },
                props.alertContent, (_b = props.nonInteractivePlaceholder) !== null && _b !== void 0 ? _b : (React.createElement(React.Fragment, null,
                !!props.header && React.createElement("div", { className: styles.header }, props.header),
                !!props.title && React.createElement(FullScreenModalTitle, { title: props.title }),
                !!props.info && React.createElement(FullScreenModalInfo, { info: props.info }),
                props.children,
                props.buttons && (React.createElement(FullScreenModalButtonContainer, null, props.buttons))))))));
};
/**
 * @description Button container for FullScreenModal. Useful for positioning your buttons anywhere inside the modal.
 */
export var FullScreenModalButtonContainer = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: styles.buttonContainer }, children));
};
export var FullScreenModalScrollContainer = function (props) {
    var _a;
    var _b;
    var mode = (_b = props.mode) !== null && _b !== void 0 ? _b : ScrollContainerMode.Narrow;
    var containerClasses = classNames(styles.scrollContainer, (_a = {},
        _a[styles.narrow] = mode === ScrollContainerMode.Narrow,
        _a[styles.fullWidth] = mode === ScrollContainerMode.FullWidth,
        _a));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: containerClasses }, props.children)));
};
